export function optionalBoolToString(val: boolean | undefined, def: boolean): string {
  if (val === undefined) {
    return def.toString();
  }

  return val.toString();
}
